/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Tags_LabelInputs */

const en_editor_tags_label = /** @type {(inputs: Editor_Tags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const fr_editor_tags_label = /** @type {(inputs: Editor_Tags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquettes`)
};

const de_editor_tags_label = /** @type {(inputs: Editor_Tags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const it_editor_tags_label = /** @type {(inputs: Editor_Tags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etichette`)
};

const ru_editor_tags_label = /** @type {(inputs: Editor_Tags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Теги`)
};

const es_editor_tags_label = /** @type {(inputs: Editor_Tags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas`)
};

const zh_cn2_editor_tags_label = /** @type {(inputs: Editor_Tags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标签`)
};

const ja_editor_tags_label = /** @type {(inputs: Editor_Tags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグ`)
};

const hi_editor_tags_label = /** @type {(inputs: Editor_Tags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टैग`)
};

const pt_pt2_editor_tags_label = /** @type {(inputs: Editor_Tags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas`)
};

/**
* | output |
* | --- |
* | "Tags" |
*
* @param {Editor_Tags_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_tags_label = /** @type {((inputs?: Editor_Tags_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Tags_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_tags_label(inputs)
	if (locale === "de") return de_editor_tags_label(inputs)
	if (locale === "it") return it_editor_tags_label(inputs)
	if (locale === "ru") return ru_editor_tags_label(inputs)
	if (locale === "es") return es_editor_tags_label(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_tags_label(inputs)
	if (locale === "ja") return ja_editor_tags_label(inputs)
	if (locale === "hi") return hi_editor_tags_label(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_tags_label(inputs)
	return en_editor_tags_label(inputs)
});